// store/chat.js

const state = {
    chats: [
      { id: 1, name: 'John Doe', lastMessage: 'Hey, how are you?', timestamp: '10:30 AM' },
      { id: 2, name: 'Jane Smith', lastMessage: 'See you later!', timestamp: '9:45 AM' },
    ],
    currentChat: null,
    messages: {
      1: [
        { id: 1, sender: 'John Doe', content: 'Hey, how are you?', timestamp: '10:30 AM' },
        { id: 2, sender: 'You', content: 'Im good, thanks!', timestamp: '10:31 AM' },
      ],
      2: [
        { id: 1, sender: 'Jane Smith', content: 'See you later!', timestamp: '9:45 AM' },
        { id: 2, sender: 'You', content: 'Sure, bye!', timestamp: '9:46 AM' },
      ],
    }
  };
  
  const mutations = {
    setCurrentChat(state, chatId) {
      state.currentChat = chatId;
    },
    addMessage(state, { chatId, message }) {
      state.messages[chatId].push(message);
    },
  };
  
  const actions = {
    selectChat({ commit }, chatId) {
      commit('setCurrentChat', chatId);
    },
    sendMessage({ commit }, { chatId, content }) {
      const message = {
        id: Date.now(),
        sender: 'You',
        content,
        timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
      };
      commit('addMessage', { chatId, message });
    },
  };
  
  const getters = {
    getCurrentChatMessages: (state) => {
      return state.currentChat ? state.messages[state.currentChat] : [];
    }
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
  };